export const theme = {
  colors: {
    bg: "#ffffff",
    surface: "#ffffff",
    text: "#1d1d1f",
    textSecondary: "#86868b",
    accent: "#0071e3",
    accentHover: "#0077ed",
    danger: "#ff3b30",
    dangerHover: "#ff453a",
    success: "#34c759",
    successHover: "#30b350",
    border: "#d2d2d7",
    borderLight: "#e8e8ed",
  },
  shadows: {
    sm: "0 1px 3px rgba(0, 0, 0, 0.08)",
    md: "0 4px 12px rgba(0, 0, 0, 0.1)",
    lg: "0 8px 24px rgba(0, 0, 0, 0.12)",
  },
  radius: { sm: 6, md: 8, lg: 12, xl: 16 },
  spacing: [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 56, 64],
  fonts: {
    body: "'Rubik', -apple-system, BlinkMacSystemFont, sans-serif",
  },
};
